import { AddOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";

import {
    ListDetailItemList,
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
    ListViewItem,
} from "../../components/ListDetailView";
import { useUserInfo } from "../../utils/security";

const PricelistListItem = ({ data, _onClick, dateFormat, ...props }) => {
    return <ListViewItem {...props} mainText={data.name} secondaryText={[data.clientName]} />;
};

export const PricelistsList = ({
    compact,
    loading,
    onAddPricelist,
    data,
    selectItem,
    detailId,
}) => {
    const { userInfo } = useUserInfo();
    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Ceníky"
                role="list"
                loading={loading}
                compact={compact}
                actions={[
                    {
                        title: "Přidat ceníík",
                        icon: <AddOutlined />,
                        onClick: () => onAddPricelist?.(),
                    },
                ]}>
                {/*<PricelistsSimpleFilter />*/}
            </ListDetailViewSectionHeader>
            <ListDetailViewSectionContent>
                <Box px={2}>{/* <PricelistsAdvancedFilter /> */}</Box>
                <ListDetailItemList
                    data={data}
                    loading={loading}
                    renderItem={(props) => <PricelistListItem {...props} />}
                    compact={compact}
                    detailId={detailId}
                    selectItem={selectItem}
                />
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
